<template>
  <div class="col-lg-4 padding-x-0">
      <div class="method">
        <div class="left">
            <div class="title">{{seriesInfo[series].label}}
                
            </div>
            <div class="describe">{{seriesInfo[series].describe}}</div>
        </div>
        <div class="right">
            <button v-if="numAmountofChange" v-bind:id="'i_'+seriesInfo[series].label.replace(/[\s?!+,.\\]/g, '_')" class="btn_AmountofChange">
                <div
                    class="customs-icons"
                    v-bind:class="numAmountofChange>.2? 'error': numAmountofChange<=.2&&numAmountofChange>.15? 'warning' : 'check_circle'">
                </div>
            </button>
        </div>
      </div>
      
      <div class="main" v-bind:class="{'simpleMode': simpleMode}">
        <div class="component">
            <div class="title" style="width:100%">
                <div class="col-sm text-left no-panding line-height-center">{{$t("Share.Next4Week")}}</div>
                <div class="col-sm text-right no-panding">
                    <button type="button" class="btn btn-download-csv" v-on:click="downloadCSV" v-if="window.isMobile != true">
                        <i class="material-icons">file_download</i> {{$t("Share.DownloadCSV")}}
                    </button>
                </div>
            </div>
            <chartForecast :simpleMode="simpleMode" :isNeededShowLegend="isNeededShowLegend" :dataChartReal="dataChartReal" :dataChartForecast = "dataChartForecast" :mappingWeekDay = "mappingWeekDay" v-if="dataChartReal && dataChartForecast"></chartForecast>
        </div>
        <div class="component">
            <div class="title">{{$t("Share.PredictOfNext4Week")}}</div>
            <b-table 
                class="tbl tbl_Week4Predict"
                striped 
                :fields="fieldWeek4Predict" 
                :items="itemWeek4Predict"   
            >
                <template slot="model" slot-scope="data" @click.stop="this">
                    <a :href="getWikiLink(data.value)" target="_black">{{data.value}}</a>
                </template>
                <template slot="1wk" slot-scope="data">
                    {{getNumberofPeople(data.value)}}
                </template>
                <template slot="2wk" slot-scope="data">
                    {{getNumberofPeople(data.value)}}
                </template>
                <template slot="3wk" slot-scope="data">
                    {{getNumberofPeople(data.value)}}
                </template>
                <template slot="4wk" slot-scope="data">
                    {{getNumberofPeople(data.value)}}
                </template>
            </b-table>
        </div>
        <div class="component">
            <div class="title">
                {{$t("Share.PredictModelPerformanceNextWeek")}}
                <b-form-select :options="itemWeekSelectValue" v-model="localWeekSelectValue"></b-form-select>
            </div>
            <b-table 
                class="tbl tbl_Week1Model"
                striped 
                :fields="fieldWeek1Model" 
                :items="itemWeek1ModelFilter"   
            >
                <template slot="model" slot-scope="data" @click.stop="this">
                    <a :href="getWikiLink(data.value)" target="_black">{{data.value}}</a>
                </template>
                <template slot="mape" slot-scope="data">
                    {{getNumberofPercent(data.value)}}
                </template>
                <template slot="hit_rate" slot-scope="data">
                    {{getNumberofPercent(data.value)}}
                </template>
            </b-table>
        </div>
      </div>
      <b-tooltip 
        v-if="numAmountofChange"
        v-bind:target="'i_'+seriesInfo[series].label.replace(/[\s?!+,.\\]/g, '_')" placement="right" 
        v-bind:class="numAmountofChange>.2? 'error': numAmountofChange<=.2&&numAmountofChange>.15? 'warning' : 'check_circle'">
        {{numAmountofChange>0? $t("Share.CompareWithLastWeek.Up") : $t("Share.CompareWithLastWeek.Down")}}<strong>{{getNumberofPercent(Math.abs(numAmountofChange))}}</strong>
      </b-tooltip>
  </div>
</template>

<script>
import * as d3 from 'd3';
import * as Papa from 'papaparse';

import Vue from 'vue'
import chartForecast from "./chartForecast";

export default {
  name: 'AllTWComponent',
  props: [ 'series', 'isNeededShowLegend', 'WeekSelectValue', 'simpleMode'],
  components: { chartForecast },
  data() {
      return {
          window: window,
          seriesInfo: {
              'RODS': {label: this.$i18n.t("Visits.EmergencyVisit"), describe: this.$i18n.t("Visits.EmergencySource")},
              'NHI': {label: this.$i18n.t('Visits.OutpatientVisit'), describe: this.$i18n.t("Visits.OutpatientSource")},
              'RODS_NHI': {label: this.$i18n.t('Visits.All'), describe: this.$i18n.t("Visits.AllSource")}
          },
          fieldWeek4Predict: [
              {key: "model", label: this.$i18n.t("Share.Model"), sortable: false},
              {key: "1wk", label: "第一週", sortable: false},
              {key: "2wk", label: "第二週", sortable: false},
              {key: "3wk", label: "第三週", sortable: false},
              {key: "4wk", label: "第四週", sortable: false}
          ],
          itemWeek4Predict: [],
          fieldWeek1Model: [
              {key: "model", label: this.$i18n.t("Share.Model"), sortable: false},
              {key: "mape", label: this.$i18n.t("Share.MAPE"), sortable: false},
              {key: "hit_rate", label: this.$i18n.t("Share.HitRate"), sortable: false}
          ],
          itemWeek1Model: [],
          itemWeek1ModelFilter: [],
          itemWeekSelectValue: [
            { value: 4, text: this.$i18n.t("Share.RecentWeek.Four") },
            { value: 8, text: this.$i18n.t("Share.RecentWeek.Eight") },
            { value: 52, text: this.$i18n.t("Share.RecentWeek.FiftyTwo") }
          ],
          dataChartReal: undefined,
          dataChartForecast: undefined,
          numAmountofChange: undefined,
          localWeekSelectValue: 52,
          randomValue: Math.random(),
          mappingWeekDay: undefined
      }
  },
  methods: {
      getNumberofPeople: function(val){
          return d3.format(",.0f")(val);
      },
      getNumberofPercent: function(val){
          return val===undefined ? "" : d3.format(".2%")(val);
      },
      getChartData: function(){
            let _this = this;
            
            //Get Real data
            Vue.axios.get(`static/Data/Taiwan/${this.series}/Latest_4_Weeks_Forecast_Chart/real_value.csv?rand=${this.randomValue}`).then((res)=>{
                if(res.status != 200){
                    //get file error
                }
                else{
                    _this.dataChartReal = d3.csvParse(res.data);
                    _this.dataChartReal.forEach(element => {
                        element.realValue = +element.realValue
                    });

                    //Get the amount of change
                    this.getAmountofChange();

                    //Emit to parent
                    _this.$emit('getChartReal', {series: _this.series, data: _this.dataChartReal})
                }
            });
            //Get mapping table for week-day
            Vue.axios.get(`static/Data/Reference/date_week_mapping.csv?rand=${this.randomValue}`).then((res)=>{
                if(res.status != 200){

                }
                else{
                    this.mappingWeekDay = d3.csvParse(res.data)
                }
            })
            .then(()=>{
                Vue.axios.get(`static/Data/Taiwan/${this.series}/Latest_4_Weeks_Forecast_Chart/forecast_value.csv?rand=${this.randomValue}`).then((res)=>{
                    if(res.status != 200){

                    }
                    else{
                        let tmp = d3.csvParse(res.data);

                        let arrKey = Object.keys(tmp[0])
                        arrKey.splice(arrKey.indexOf("yearWeek"), 1);

                        tmp.forEach(element => {
                            for(let i=0;i<arrKey.length;i++){
                                element[arrKey[i]] = +element[arrKey[i]]
                            }
                        });

                        _this.dataChartForecast = tmp;
                        _this.dataChartForecast.arrKey = arrKey;

                        //Modify week
                        let weekList = _this.dataChartForecast.map((d)=>{return d.yearWeek.substring(4,6)});

                        for(let i=0;i<weekList.length;i++){
                            let objmappingWeekDay = _this.mappingWeekDay.find((d)=>{
                                    return _this.dataChartForecast[i].yearWeek == d.yearWeek;
                                }).date;
                            objmappingWeekDay = objmappingWeekDay.replace(" - ", "</br>-</br>")
                            
                            if(this.$getCookie("language") == 'en')
                                _this.fieldWeek4Predict[i+1].label = `Week ${weekList[i]}<div class="mappingWeekDay">
                                    ${objmappingWeekDay}
                                </div>`;
                            else
                                _this.fieldWeek4Predict[i+1].label = `第${weekList[i]}週<div class="mappingWeekDay">
                                    ${objmappingWeekDay}
                                </div>`;
                        }

                        //Emit to parent
                        _this.$emit('getChartForecast', {series: _this.series, data: _this.dataChartForecast, field: _this.fieldWeek4Predict})
                    }
                })
            })
            
      },
      getTableData: function(){
            //Every week
            Vue.axios.get(`static/Data/Taiwan/${this.series}/Latest_4_Weeks_Forecast_Table/forecast_value.csv?rand=${this.randomValue}`).then((res)=>{
                if(res.status != 200){
                    //get file error
                }
                else{
                    let tmpData = Papa.parse(res.data).data;
                    for(let i=1;i<tmpData.length;i++){
                        if(tmpData[i][0] != ""){
                            this.itemWeek4Predict.push({model: tmpData[i][0]})
                            for(let j=0;j<tmpData[i].length;j++){
                                if(j==0)
                                    this.itemWeek4Predict[i-1][tmpData[0][j]] = tmpData[i][j]
                                else
                                    this.itemWeek4Predict[i-1][tmpData[0][j]] = parseFloat(tmpData[i][j])
                            }
                        }
                    }

                    //Push ensemble to first
                    let objEnsemble = this.itemWeek4Predict.find((d)=>{return d.Model==="Ensemble"});
                    this.itemWeek4Predict.splice(this.itemWeek4Predict.map((d)=>{return d.Model}).indexOf(("Ensemble")),1)
                    this.itemWeek4Predict.unshift(objEnsemble);

                    //Emit to parent
                    this.$emit('getLast4Week', {series: this.series, data: this.itemWeek4Predict})
                }
            })

            //Model performance
            Vue.axios.get(`static/Data/Taiwan/${this.series}/Lag1_Backtest_MAPE_HitRate_Table/table.csv?rand=${this.randomValue}`).then((res)=>{
                if(res.status != 200){
                    //get file error
                }
                else{
                    this.itemWeek1Model = d3.csvParse(res.data);
                    //Push ensemble to first
                    let objEnsemble = this.itemWeek1Model.find((d)=>{return d.model==="Ensemble"});
                    this.itemWeek1Model.splice(this.itemWeek1Model.map((d)=>{return d.model}).indexOf(("Ensemble")),1)
                    this.itemWeek1Model.unshift(objEnsemble);

                    this.updateItemWeek1ModelFilter();

                    //Emit to parent
                    this.$emit('getLag1Backtest', {series: this.series, data: this.itemWeek1Model})
                }
            })
      },
      getAmountofChange: function(){
          let valThisWeek = this.dataChartReal[this.dataChartReal.length-1].realValue;
          let valLastWeek = this.dataChartReal[this.dataChartReal.length-2].realValue;

          this.numAmountofChange = (valThisWeek-valLastWeek)/valLastWeek;
      },
      downloadCSV: function(){
        let csvFileName = `${this.seriesInfo[this.series].label}.csv`;
        let csvRows = [];
        
        csvRows.push(`模型,${this.fieldWeek4Predict[1].label.split('<div')[0]},${this.fieldWeek4Predict[2].label.split('<div')[0]},${this.fieldWeek4Predict[3].label.split('<div')[0]},${this.fieldWeek4Predict[4].label.split('<div')[0]}`);
        for(let i=0; i<this.itemWeek4Predict.length; ++i){
            let item = this.itemWeek4Predict[i];
            csvRows.push(`${item.Model},${item['1wk']},${item['2wk']},${item['3wk']},${item['4wk']}`);
        }

        if(document.documentMode != undefined || navigator.userAgent.match("Edge") != null){ //For IE and Microsoft Edge
            if(document.documentMode>=10 || navigator.userAgent.match("Edge") != null){
                let csvContent = "\uFEFF";
                csvRows.forEach(function(infoArray, index){
                    csvContent += index < csvRows.length ? infoArray+ "\n" : infoArray;  
                });  
                var blob = new Blob([csvContent], { 
                    "type": "data:text/csv;charset=utf-8"             
                }); 

                navigator.msSaveBlob(blob, csvFileName);
            }
            else{
                alert(Vue.$i18n.t("Share.NotSupportingIE"));
            }
        }

        else{   //For chrome, firefox
            let csvString = csvRows.join("%0A");
            let a         = document.createElement('a');
            a.href        = 'data:application/csv;charset=utf-8,%EF%BB%BF' + csvString;
            a.target      = '_blank';
            a.download    = csvFileName;

            document.body.appendChild(a);
            a.click();        
        }
      },
      updateItemWeek1ModelFilter: function(){
          this.itemWeek1ModelFilter = this.itemWeek1Model.map((d)=>{return {model: d.model, mape: d['mape_'+this.WeekSelectValue], hit_rate: d['hit_rate_'+this.WeekSelectValue]}});
      },
      getWikiLink: function(modelName){
          switch(modelName){
              case 'Ensemble':
                return 'https://zh.wikipedia.org/wiki/%E9%9B%86%E6%88%90%E5%AD%A6%E4%B9%A0';
              break;
              case 'ARIMA':
                return 'https://zh.wikipedia.org/wiki/ARIMA%E6%A8%A1%E5%9E%8B';
              break;
              case 'RF':
                return 'https://zh.wikipedia.org/zh-tw/%E9%9A%8F%E6%9C%BA%E6%A3%AE%E6%9E%97';
              break;
              case 'SVR':
                return 'https://en.wikipedia.org/wiki/Support_vector_machine#Regression';
              break;
              case 'XGB':
                return 'https://en.wikipedia.org/wiki/Gradient_boosting';
              break;
          }
          
      }
  },
  mounted: function(){
      this.getTableData();
      this.getChartData();
  },
  watch: {
      localWeekSelectValue: function(){
          this.$emit('ChangedWeekSelectValue', this.localWeekSelectValue);
      },
      WeekSelectValue: function(){
          this.localWeekSelectValue = this.WeekSelectValue;
          this.updateItemWeek1ModelFilter();
      }
  }
}
</script>

<style lang="scss" scoped>
    @keyframes flash {  
        0% { opacity: 1.0 }
        50% { opacity: 0.3 }
        100% { opacity: 1.0 }
    }
    
    .line-height-center{
        align-items: center;
        display: flex;
    }

    .btn_AmountofChange{
        background-color: rgba(255,255,255,0);
        border: none;
        padding: 0;
        margin: 0;
        
    }

    .padding-x-0 {
        @media (max-width: 767.98px) { 
            padding-right: 0px;
            padding-left: 0;    
        }
    }
      
    .col-md{
        padding: 0 16px;
    }

    .method{ 
        margin-top: 8px; 
        margin-bottom: 8px;
        display: flex;
        .left{
            .title{
                margin-bottom: -4px;

                font-size: 18px;
                display: inline-flex;
                vertical-align: middle;
            }
            .describe{
                font-size: 14px;
                color: #9e9e9e;
            }
        }
        .right{
            .customs-icons{
                width: 40px;
                height: 38px;
                margin-left: 4px;
                cursor: help;
            }

            .customs-icons.check_circle{            
                color: #4CAF50;

                background-image: url('../../static/images/icons/good-lg.png');
                background-size: 40px 38px;
                background-repeat: no-repeat;

            }

            .customs-icons.warning{            
                color: #ffc107;

                background-image: url('../../static/images/icons/warning-lg.png');
                background-size: 40px 38px;
                background-repeat: no-repeat;

                animation-name: flash;
                animation-duration: 1s;
                animation-iteration-count: 8;
            }

            .customs-icons.error{
                color:#F44336;

                background-image: url('/static/images/icons/error-lg.png');
                background-size: 40px 38px;
                background-repeat: no-repeat;

                animation-name: flash;
                animation-duration: 1s;
                animation-iteration-count: 8;
            }
        }
    }

    .method.describe{
        margin-bottom: 8px;
        font-size: 14px;
        color: #9e9e9e;
    }

    .method{
        @media (max-width: 767.98px) { 
            margin-top: 8px; 
            font-size: 20px;
            margin-left: 16px;
        }

        @media (min-width: 767.98px){        
            font-size: 16px;
        }
    }

    .main{
        padding: 16px;
        border-radius: 4px;
        background-color: #FFF;
        color:#000;
        
        -webkit-transition: height 2s; /* Safari */
        transition: height 2s;
        .title {
            margin-bottom: 8px;
        }
        .component{
            min-height: 275px;
            margin-bottom: 16px;
            .title{
                display: inline-flex;
                vertical-align: middle;
                align-items: center;
                select {
                    width: 132px;
                    height: calc(2rem + 2px);
                    margin-left: 16px;
                    font-size: 14px;
                    padding: 4px;
                }
                label {
                    height: calc(2rem + 2px);
                }
                
            }
        }
    }

    .tbl{
        word-break:break-all;
        :global(thead){
            :global(tr){
                font-size: .85rem;
                @media (min-width: 1400px){
                    font-size: 1rem;
                }

                :global(th){                
                    padding: .75rem .35rem;
                }
            }

            :global(tr):first-child{
                background-color: #757782;
                color: #ffffff;
                //text-align: right;
                text-align: center;
                line-height: 1;
                :global(th):first-child{
                    text-align: left;
                }
            }
        }

        :global(tbody){
            :global(tr){
                font-size: .85rem;
                a{
                    color: #000;
                    text-decoration: underline;
                }
                a:hover{
                    color: #607d8b;
                }
                &:first-child{
                    &:a{
                        color: rgb(56, 46, 46);
                    }
                    &:first-child{
                        a{
                            color: #0714ef;
                        }
                        font-weight: bold;
                        //color: #E35959;
                        color: #0714ef;
                    }
                }
            }
            :global(tr)>:global(td){
                padding: .75rem .35rem;
            }

            :global(tr)>:global(td:not(:first-child)){
                text-align: right;
            }
        }
    }

    .tbl.tbl_Week4Predict{
        :global(thead){
            :global(th:first-child){
                width: 20%
            }

            :global(th:not(:first-child)){
                width: 20%;
            }
        }
    }

    .tbl.tbl_Week1Model{
        :global(thead){
            :global(th:first-child){
                width: 20%
            }

            :global(th:not(:first-child)){
                width: 40%;
            }
        }
    }

    .simpleMode{  
      height: 375px;
      overflow-y: hidden;
    }
</style>
<style>
    .mappingWeekDay{
        margin-top: 4px; 
        font-size: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/AllTWComponent.vue